module.exports = __webpack_public_path__ + "static/media/Slide1.f0e8e88a.jpeg";